import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { statusColor } from 'utils/common';

import classes from './OngoingMarker.module.scss';

const OngoingMarker = ({ mode, status }) => {
  return (
    <div
      className={cn(
        classes.isOnGoing,
        mode === 'cell' ? classes.isOnGoing_cell : classes.isOnGoing_sub
      )}
    >
      <div
        className={classes.isOnGoing_marker}
        style={{ backgroundColor: statusColor(status) }}
      />
      <span className={classes.visually_hidden}>{status}</span>
    </div>
  );
};

OngoingMarker.propTypes = {
  mode: PropTypes.string,
  status: PropTypes.string
};

export default OngoingMarker;
